import React, { useCallback, useEffect, useState } from 'react';

import style from './style.module.scss';
import AddNewWizards from '@components/app-bar/add-new-wizards';
import useWindowDimensions from '@hooks/useWindowDimensions';
import FilterHeader from '@components/filters/filter-header';

const PSVEquipmentModal = ({
  closedModal,
  open,
  noGap = false,
  selectedPSVEquipmentEvent,
  alreadyAttachedPSV,
  siteId = null
}) => {
  const { width } = useWindowDimensions();
  const [initialY, setInitialY] = useState(null);
  const [isActive, setIsActive] = useState(open);

  useEffect(() => {
    if (open) document.body.classList.add('filter-open');
    else document.body.classList.remove('filter-open');
  }, [open]);

  const startTouch = useCallback((e) => setInitialY(e.touches[0].clientY), []);

  const moveTouch = useCallback((e) => {
    let currentY = e.touches[0].clientY;
    let diffY = initialY - currentY;
    if (diffY < 0) {
      console.log('ooo');
      setIsActive(false);

      setTimeout(() => {
        closedModal(false);
      }, 1000);
    }
    setInitialY(e.touches[0].clientY);
  }, []);

  return (
    <>
      {width >= 768 ? (
        <div className={style.psvModalContainer}>
          <div className={`${style.header} px-4 md:px-8 py-7`}>
            <p
              className={style.cancelClass}
              onClick={() => {
                closedModal(true);
              }}
            >
              Cancel
            </p>
            <h1 className={`${style.addClass} h1-semibold`}>Select the PSV</h1>
            <div className={style.invisibleDiv}>Cancel</div>
          </div>

          <AddNewWizards
            addNew={'psv-equipment'}
            setAddNew={() => {}}
            setActive={() => {}}
            setSelectedPSVEvent={({ id }) => {
              selectedPSVEquipmentEvent({ id });
            }}
            psvEquipment
            alreadyAttachedPSV={alreadyAttachedPSV}
            siteId={siteId}
          />
        </div>
      ) : (
        <>
          <div
            className={`op-sidebarfilter ${isActive && 'open'} ${!noGap && 'gap'} ${
              isActive ? style.isActivePadding : style.isInActivePadding
            }`}
          >
            <div
              onTouchStart={startTouch}
              onTouchMove={moveTouch}
              className={`${isActive ? style.paddingLeftAndRight : style.isInActivePadding}`}
            >
              <FilterHeader
                title="Select the PSV"
                filterCount={0}
                resetBtnEvent={() => {}}
                leftBtnEvent={() => {}}
                openBookmarkModalEvent={() => {}}
                bookmarkId={false}
                isFilterChangedInBookmark={false}
                width={width}
                detailPage
              />
            </div>
            <AddNewWizards
              addNew={'psv-equipment'}
              setAddNew={() => {}}
              setActive={() => {}}
              psvEquipment
              setSelectedPSVEvent={({ id }) => {
                selectedPSVEquipmentEvent({ id });
              }}
              alreadyAttachedPSV={alreadyAttachedPSV}
              siteId={siteId}
            />
          </div>
        </>
      )}
    </>
  );
};

export default PSVEquipmentModal;
